import React from 'react';
import { connect } from 'react-redux';
import findResult, { findSelected } from '@/utils/resultsHelper';
import AuditAction from '@/audit//components/AuditAction';
import { states } from '@/constants/lifecycle';
import { collectionUrl } from '@/constants/urls';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import EditAction from '@/components/ribbon-actions/EditAction';
import { datasetManagePermissions } from '@/datasets/sharing/constants';
import {
  confirmCollectionDeletion,
  editCollection,
} from '../actions';
import CancelCollectionAction from './CancelCollectionAction';
import SaveCollectionAction from './SaveCollectionAction';
import ShareCollectionAction from '../sharing/containers/ShareCollectionAction';
import ManageCollectionAction from './AssignCollectionAction';
import { collectionPermissions } from '../sharing/constants';
import { collectionPerms } from '../sharing/state/state';

const accessControl = (
  role,
  perms,
  isEditing = false,
  disableEdit = true,
  disableAdd = true,
  disableRemove = true,
) => {
  const { collections } = role.permissions;
  return (
    {
      allowEdit: collections.update || perms[collectionPermissions.UPDATE],
      allowDelete: collections.destroy || perms[collectionPermissions.DESTROY],
      allowAudit: collections.audit || perms[collectionPermissions.AUDIT],
      allowManage: collections.datasets || perms[collectionPermissions.DATASETS],
      allowSecure: collections.secure || perms[collectionPermissions.SECURITY],
      allowShare: collections.share || (perms[collectionPermissions.INVITE_MEMBER]
          || perms[collectionPermissions.REMOVE_MEMBER]),
      disableEdit,
      disableAdd: disableAdd || disableEdit || isEditing,
      disableRemove: disableRemove || disableEdit || isEditing,
    });
};

const withoutItem = (role) => ({
  exists: false,
  url: '',
  ...accessControl(role, collectionPerms()),
});

const withItem = (item, role, datasets) => {
  const disableAdd = false;
  let denyRemove = !role.permissions.collections.datasets;
  const selected = findSelected(datasets, true);
  if (denyRemove) {
    denyRemove = selected.some((dataset) => !dataset.permissions[datasetManagePermissions.COLLECTIONS]);
  }
  const disableRemove = denyRemove || item.readStatus === states.PENDING || selected.length === 0;
  const perms = item.permissions;
  const disableEdit = !!item.isDirty || item.readStatus === states.PENDING;

  return {
    exists: true,
    url: collectionUrl(item, '#'),
    name: item.name,
    isEditing: item.isEditing,
    isNew: item.isNew,
    ...accessControl(role, perms, item.isEditing, disableEdit, disableAdd, disableRemove),
  };
};

const CollectionActions = ({
  code,
  category,
  allowEdit,
  disableEdit,
  showEdit,
  isEditing,
  allowDelete,
  allowShare,
  allowSecure,
  disableShare,
  allowAudit,
  disableAudit,
  url,
  showDelete,
  disableDelete,
  allowManage,
  disableAdd,
  disableRemove,
  isNew,
}) => (
  <>
    {allowEdit && !isEditing && (<EditAction onClick={() => showEdit(category, code)} disabled={disableEdit} />)}
    {allowEdit && isEditing && !isNew && (<CancelCollectionAction code={code} category={category} />)}
    {allowEdit && (<SaveCollectionAction code={code} category={category} isEditing={isEditing} />)}
    {!isNew && allowManage && (
    <ManageCollectionAction
      code={code}
      category={category}
      disableAdd={disableAdd}
      disableRemove={disableRemove}
    />
    )}
    {(!isNew && (allowShare || allowSecure)) && (
    <ShareCollectionAction
      code={code}
      category={category}
      secureOnly={allowSecure && !allowShare}
      disabled={disableShare}
    />
    )}
    {allowAudit && !isNew && (<AuditAction baseUrl={url} disabled={disableAudit} />)}
    {allowDelete && !isNew && (
    <DeleteActionMenu onClick={() => showDelete(category, code)} disabled={disableDelete} />
    )}
  </>
);

const mapStateToProps = ({
  auth: { role },
  collections: { collections },
  collectionDatasets: { collectionDatasets },
}, { category, code }) => {
  const item = findResult(collections, category, code);
  const datasets = findResult(collectionDatasets, category, code);
  const datasetItems = datasets ? datasets.results : [];

  return item ? withItem(item, role, datasetItems) : withoutItem(role);
};

const mapDispatchToProps = {
  showDelete: confirmCollectionDeletion,
  showEdit: editCollection,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionActions);
